import { useUpdateEffect } from 'ahooks'
import { InputNumber, Select, SelectProps, Space } from 'antd'
import { isNil } from 'lodash'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { ServiceFeeGradientTooltip } from '@eastcoal/shared/components/ServiceFeeGradientTooltip'
import {
  FeeMethod,
  FeeMethodTextMap,
  FeeMethodUnitMap
} from '@eastcoal/shared/enums/FeeMethod'

import { ServiceFeeInputProps } from './interface'

const defaultOptions = mapNumberEnumOptions(
  FeeMethodTextMap
) as SelectProps['options']

const Component = ({
  selectOptions: externalOptions,
  disabled,
  value = {},
  onChange
}: ServiceFeeInputProps) => {
  const serviceFeeValueDisabled =
    value.serviceFeeMethod === FeeMethod.NONE ||
    value.serviceFeeMethod === FeeMethod.GRADIENT

  // 当没有服务费时清空已输入的服务费金额
  useUpdateEffect(() => {
    if (serviceFeeValueDisabled && !isNil(value.serviceFeeValue)) {
      onChange?.({ ...value, serviceFeeValue: 0 })
    }
  }, [value.serviceFeeMethod])

  const handleSelectChange = (serviceFeeMethod: FeeMethod) => {
    onChange?.({
      ...value,
      serviceFeeMethod
    })
  }

  const handleInputChange = (serviceFeeValue: number | string | null) => {
    onChange?.({
      ...value,
      serviceFeeValue: isNil(serviceFeeValue) ? 0 : Number(serviceFeeValue)
    })
  }

  const finalDisabled = disabled || serviceFeeValueDisabled

  const addonAfterNode = isNil(
    value.serviceFeeMethod
  ) ? undefined : value.serviceFeeMethod === FeeMethod.GRADIENT ? (
    <ServiceFeeGradientTooltip />
  ) : (
    FeeMethodUnitMap[value.serviceFeeMethod]
  )
  const options = externalOptions ?? defaultOptions

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.serviceFeeMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={finalDisabled}
        min={0}
        value={value.serviceFeeValue}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange}
      />
      {addonAfterNode && <span>{addonAfterNode}</span>}
    </Space.Compact>
  )
}

export const ServiceFeeInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
